<template>
  <contacts-form v-model="contactInfo"/>
</template>

<script>
import contactsForm from '@/components/forms/ContactsForm'
export default {
  data () {
    return {
      contactInfo: {}
    }
  },

  components: {
    contactsForm
  },

  mounted () {
    this.axios.get('contacts')
      .then((res) => {
        if (res.data.length) {
          this.contactInfo = res.data[0]
        }
      })
  }
}
</script>

<style lang="scss" scoped>

</style>
